<template lang="pug">
    .row
      .col-md-12
        .text-center.loading(v-if="loading")
          i.fa.fa-spinner.fa-pulse.fa-spin
        .panel.panel-default(v-else)
          .panel-heading
            .panel-title User General Info
          .panel-body
            .row
              label.col-sm-2 Name
              .col-sm-4 {{user.username}}
              label.col-sm-2 Email
              .col-sm-4 {{user.email}}
            .row
              label.col-sm-2 Enabled
              .col-sm-4 {{user.enabled ? 'Yes' : 'No'}}
              label.col-sm-2 Default Group
              router-link.col-sm-4(:to="{name: 'group', params: {id: defaultGroupId}}" v-if="defaultGroupId") {{user.defaultGroup.name}}
            .row
              label.col-sm-2 Credentials Expired
              .col-sm-4 {{user.credentialsExpired ? 'Yes' : 'No'}}
              label.col-sm-2 Locked
              .col-sm-4.fa(:class="user.locked ? 'fa-lock' : 'fa-unlock'")
            hr
            .row
              label.col-sm-2 Groups
              .col-sm-10(v-if="groups")
                PillsList(:items="groups" :clickable="true" :removable="true" :defaultGroup="defaultGroupId" @removeClick="removeGroup" @itemClick="goToGroup")
              span(v-else)
                em.text-muted Not part of any group
            hr
            .row
              label.col-sm-2 Roles
              .col-sm-10(v-if="roles")
                PillsList(:items="roles")
              .col-sm-10(v-else)
                em.text-muted User has no roles
            hr
            .row
              label.col-sm-2 Phone Numbers
              .col-sm-10(v-if="phonenumbers")
                PillsList(:items="phonenumbers")
              .col-sm-10(v-else)
                em.text-muted User has no phonenumbers
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import PillsList from '@/components/common/PillsList'

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    groups: null,
    defaultGroupId: null,
  }),
  methods: {
    reload() {
      this.init()
    },
    init() {
      Security.listUserGroups(this.user.id, { max: 1000 })
        .then((resp) => {
          this.groups = resp.data.content
        })
        .then(() => {
          this.defaultGroupId = this.user.defaultGroup.id
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    goToGroup(data) {
      this.$router.push({ name: 'group', params: { id: data.id } })
    },
    removeGroup(data) {
      const req = {
        groupId: data.id,
        userId: this.user.id
      }
      Security.removeUserFromGroup(data.id, this.user.id, req)
        .then(() => {
          miniToastr.success(`Group ${data.name} was removed`)
          this.reload()
        })
    }
  },
  watch: {
    user() {
      if (this.user) {
        this.init()
      }
    }
  },
  computed: {
    roles() {
      return this.user.roles ? this.user.roles.role.map((r) => ({ name: r })) : []
    },
    phonenumbers() {
      return this.user.phoneNumbers ? this.user.phoneNumbers.phoneNumber.map((p) => ({ name: p })) : []
    }
  },
  components: {
    PillsList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/user/UserDetails.vue